import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M20 6 9 17l-5-5" })
], -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["bs-checkbox", {
            'bs-checkbox--disabled': _ctx.disabled,
            'bs-checkbox--checked': _ctx.modelValue,
            'bs-checkbox--small': _ctx.size === 'small',
            'bs-checkbox--medium': _ctx.size === 'medium',
            'bs-checkbox--big': _ctx.size === 'big',
            'bs-checkbox--royal-blue': _ctx.color === 'royal-blue',
        }]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onToggle && _ctx.onToggle(...args)))
  }, _hoisted_2, 2))
}